import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/root';
import { loginRoute } from './routes/login';
import { cockpitRoute } from './routes/cockpit';
import { consoleRoute } from './routes/console';
import { liveRoute } from './routes/live';
import { responsivenessRoute } from './routes/responsiveness';
import { poolTimeRoute } from './routes/pool-time';
import { dialRoute } from './routes/dial';
import { callHistoryRoute } from './routes/call-history';
import { RouteNotFound } from './components/route-error';

const routeTree = rootRoute.addChildren([
  loginRoute,
  cockpitRoute,
  consoleRoute,
  liveRoute,
  responsivenessRoute,
  poolTimeRoute,
  dialRoute,
  callHistoryRoute,
]);

// No `defaultErrorComponent`: it applies to every route naming none, and the
// only way out is `errorComponent: false`, which removes that route's boundary
// rather than choosing another screen. A default carrying the operator page
// strip would therefore mean either showing it to an SDR whose calling surface
// broke, or leaving that surface unguarded. Each route names its own instead.
//
// The not-found default is separate wiring from the root route's
// `notFoundComponent`: that one decides whether the boundary is mounted at all,
// this one is what a child falls back to when it names no screen of its own.
// Removing either leaves a case on the library's bare `Not Found`.
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultNotFoundComponent: RouteNotFound,
});

// Register the router instance for end-to-end type inference of links/navigation.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
